import { Stack, Typography } from '@mui/material';
import ThreeLogoCircle from 'assets/icons/three-logo-circle.svg';
import { ReactSVG } from 'react-svg';

const PaymentHeader = () => (
  <Stack direction="row" gap={2} alignItems="center" width="100%" pb={4}>
    <ReactSVG src={ThreeLogoCircle} width={30} height={30} />

    <Typography variant="h3" mb="3px">
      THREE by Berkshire Hathaway
    </Typography>
  </Stack>
);

export default PaymentHeader;
